import { useState } from "react";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import SecurityHeaders from "../../context/SecurityHeaders";
import SnackbarToast from "../../components/toasts/SnackbarToast";
import { useDispatch } from "react-redux";

const EbookUploader = ({bookId,reload,handelClose}) => {
    const dispatch = useDispatch()
     const [open, setOpen] = useState({
            open: false,
            message: '',
            type: ''
    
        });
    const [pageNo, setPageNo] = useState("");
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        dispatch({type:'LOADING'})

        if (!bookId || !pageNo || !file) {
            console.log(bookId, pageNo, file);
            dispatch({ type: "ERROR", payload: "Only JPEG, PNG, or JPG images are allowed." });

            setMessage("Please fill all fields and select an image.");
            return;
        }
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            dispatch({ type: "ERROR", payload: "Image size must be less than 5MB." });
            return;
        }
       
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
     
        if (!allowedTypes.includes(file.type)) {
            dispatch({ type: "ERROR", payload: "Only JPEG, PNG, or JPG images are allowed." });
            return;
        }
      


        const formData = new FormData();
        formData.append("book_id", bookId);
        formData.append("page_no", pageNo);
     
        formData.append("image", file);
     

        try {
            const response = await axios.post(ENDPOINT+"add-book-pages.php",formData,SecurityHeaders);

            if (response.data.status === "success") {
                setOpen((prev)=>({...prev, open: true, message:'Added Successfully', type: "success" }));
                dispatch({type:'DONE_LOADING'})

                setMessage(`✅ Upload Successful: ${response.data.image_url}`);
                handelClose();
                reload();
            } else {
                dispatch({type:'ERROR', payload:'Error occurred while adding book'})
                setMessage(`❌ Error: ${response.data.message}`);
            }
        } catch (error) {
dispatch({trype:'ERROR', payload:error.message})            
            setMessage("❌ Network error. Try again!");
        }
    };

    return (
      <>
        <SnackbarToast open={open} handleClose={() => setOpen((pre) => ({ ...pre, open: false }))} />

<div className="container mt-4">
    <h2>Upload eBook Page</h2>
    <form onSubmit={handleSubmit} className="p-3 border rounded">
        

        <div className="mb-3">
            <label className="form-label">Page Number</label>
            <input
                type="number"
                className="form-control"
                value={pageNo}
                onChange={(e) => setPageNo(e.target.value)}
                required
            />
        </div>

        <div className="mb-3">
            <label className="form-label">Upload Image</label>
            <input type="file" accept="images/*" className="form-control" onChange={handleFileChange} required />
        </div>

        <button type="submit" className="btn btn-primary">Upload</button>
    </form>

    {message && <p className="mt-3">{message}</p>}
</div></>
    );
};

export default EbookUploader;
